import { render, staticRenderFns } from "./unknow.vue?vue&type=template&id=dc5d4a5c&"
import script from "./unknow.vue?vue&type=script&lang=js&"
export * from "./unknow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports